﻿if ($("#scCustomTrackers").length > 0) {
    $("#scCustomTrackers").children("input:hidden").each(function (i, val) {
        var trackclass = $(this).data('trackclass');
        var trackgoal = $(this).data('trackgoal');
       
        $('body').find('a.' + trackclass).each(function (i, obj) {
            $(obj).attr('onclick', 'sctrack("' + trackgoal + '")');
        });
       
    });

}